import service from "@irati/utils/tracking";
import { DealSagaStep } from "@irati/deals/enums/SagaV2";
var PerksTrackingEvents = /** @class */ (function () {
    function PerksTrackingEvents() {
    }
    PerksTrackingEvents.prototype.viewHome = function () {
        service.trackPerksEvent("perks_view_home");
    };
    PerksTrackingEvents.prototype.clickBrowseByCategory = function () {
        service.trackPerksEvent("perks_click_browse_by_category");
    };
    PerksTrackingEvents.prototype.viewPerk = function (deal) {
        var data = {
            perk_id: deal.uuid,
            perk_name: deal.header,
            perk_slug: deal.urlSlug,
            perk_type: deal.type,
            perk_category: deal.tags
        };
        service.trackPerksEvent("perks_view_perk", data);
    };
    PerksTrackingEvents.prototype.favouritePerk = function (deal, location) {
        var data = {
            perk_id: deal.uuid,
            perk_name: deal.header,
            perk_slug: deal.urlSlug,
            perk_category: deal.tags,
            action_location: location
        };
        service.trackPerksEvent("perks_favourite_perk", data);
    };
    PerksTrackingEvents.prototype.unfavouritePerk = function (deal, location) {
        var data = {
            perk_id: deal.uuid,
            perk_name: deal.header,
            perk_slug: deal.urlSlug,
            perk_category: deal.tags,
            action_location: location
        };
        service.trackPerksEvent("perks_unfavourite_perk", data);
    };
    PerksTrackingEvents.prototype.viewTerms = function (deal) {
        var data = {
            perk_id: deal.uuid,
            perk_name: deal.header,
            perk_slug: deal.urlSlug,
            perk_category: deal.tags
        };
        service.trackPerksEvent("perks_view_terms", data);
    };
    PerksTrackingEvents.prototype.startRedeemPerk = function (deal) {
        var data = {
            perk_id: deal.uuid,
            perk_name: deal.header,
            perk_slug: deal.urlSlug,
            perk_type: deal.type,
            perk_type_highlight: deal.typeHighlight,
            perk_category: deal.tags
        };
        service.trackPerksEvent("perks_start_redeem_perk", data);
    };
    PerksTrackingEvents.prototype.redeemPerkSagaStatus = function (deal, saga) {
        var data = {
            perk_id: deal.uuid,
            perk_name: deal.header,
            perk_slug: deal.urlSlug,
            perk_type: deal.type,
            perk_type_highlight: deal.typeHighlight,
            perk_category: deal.tags
        };
        switch (saga.nextStep) {
            case DealSagaStep.Order:
                service.trackPerksEvent("perks_redeem_perk_order_product", data);
                break;
            case DealSagaStep.Update:
                service.trackPerksEvent("perks_redeem_perk_update_details", data);
                break;
            case DealSagaStep.Pay:
                service.trackPerksEvent("perks_redeem_perk_start_checkout", data);
                break;
            default:
        }
    };
    PerksTrackingEvents.prototype.redeemPerkCopyCode = function (deal) {
        var data = {
            perk_id: deal.uuid,
            perk_name: deal.header,
            perk_type: deal.type
        };
        service.trackPerksEvent("perks_redeem_perk_copy_code", data);
    };
    PerksTrackingEvents.prototype.redeemPerkFollowLink = function (deal) {
        var data = {
            perk_id: deal.uuid,
            perk_name: deal.header,
            perk_type: deal.type
        };
        service.trackPerksEvent("perks_redeem_perk_follow_link", data);
    };
    PerksTrackingEvents.prototype.redeemPerkCompleteCheckout = function (deal, amount, currency, walletSpend) {
        var data = {
            perk_id: deal.uuid,
            perk_name: deal.header,
            perk_slug: deal.urlSlug,
            perk_type: deal.type,
            perk_type_highlight: deal.typeHighlight,
            perk_category: deal.tags,
            perk_currency: currency,
            wallet_used: !!walletSpend,
            wallet_used_balance: walletSpend || null,
            transaction_amount: amount
        };
        service.trackPerksEvent("perks_redeem_perk_complete_checkout", data);
    };
    PerksTrackingEvents.prototype.redeemBirthdayBoxPerkComplete = function (dateOfBirth) {
        var data = {
            user_date_of_birth: dateOfBirth
        };
        service.trackPerksEvent("perks_redeem_birthday_box", data);
    };
    PerksTrackingEvents.prototype.startSearch = function () {
        service.trackPerksEvent("perks_start_search");
    };
    PerksTrackingEvents.prototype.clickSearchResult = function (deal) {
        var data = {
            perk_id: deal.uuid,
            perk_name: deal.header,
            perk_slug: deal.urlSlug,
            perk_category: deal.tags
        };
        service.trackPerksEvent("perks_click_search_result", data);
    };
    PerksTrackingEvents.prototype.abandonSearch = function (resultsLength, searchTerm) {
        var data = {
            search_number_of_results: resultsLength,
            search_query: searchTerm
        };
        service.trackPerksEvent("perks_abandon_search", data);
    };
    PerksTrackingEvents.prototype.clickHomepagePerk = function (deal, trackingData) {
        var sectionHeader = trackingData.sectionHeader, position = trackingData.position, userLocation = trackingData.userLocation;
        var data = {
            perk_id: deal.uuid,
            perk_name: deal.header,
            perk_slug: deal.urlSlug,
            perk_category: deal.tags,
            lane_name: sectionHeader,
            perk_position: position
        };
        var location = deal.location;
        if (location) {
            data.perk_location = location.city;
        }
        if (userLocation) {
            data.user_location = userLocation;
        }
        service.trackPerksEvent("perks_click_homepage_perk", data);
    };
    PerksTrackingEvents.prototype.viewCategory = function (categoryName) {
        var data = { category_name: categoryName };
        service.trackPerksEvent("perks_view_category", data);
    };
    PerksTrackingEvents.prototype.viewTag = function (tagName) {
        var data = { tag_name: tagName };
        service.trackPerksEvent("perks_view_tag", data);
    };
    PerksTrackingEvents.prototype.viewPerkNearestLocation = function (deal) {
        var data = {
            perk_id: deal.uuid,
            perk_name: deal.header,
            perk_slug: deal.urlSlug,
            perk_type: deal.type,
            perk_category: deal.tags
        };
        service.trackPerksEvent("perks_view_perk_nearest_location", data);
    };
    PerksTrackingEvents.prototype.viewMyPerks = function () {
        service.trackPerksEvent("perks_view_my_perks");
    };
    PerksTrackingEvents.prototype.clickPerkNearestLocation = function (deal) {
        var data = {
            perk_id: deal.uuid,
            perk_name: deal.header,
            perk_slug: deal.urlSlug,
            perk_type: deal.type,
            perk_category: deal.tags
        };
        service.trackPerksEvent("perks_click_perk_nearest_location", data);
    };
    PerksTrackingEvents.prototype.perksCategoryExperiment = function (experimentName, experimentChoice) {
        var data = {
            experiment_name: experimentName,
            experiment_choice_received: experimentChoice
        };
        service.trackPerksEvent("perks_category_experiment", data);
    };
    PerksTrackingEvents.prototype.markPerkUsed = function (deal) {
        var data = {
            perk_id: deal.uuid,
            perk_name: deal.header
        };
        service.trackPerksEvent("perks_mark_perk_used", data);
    };
    PerksTrackingEvents.prototype.viewZipModal = function () {
        service.trackPerksEvent("perks_view_zip_modal");
    };
    PerksTrackingEvents.prototype.moreAboutZip = function () {
        service.trackPerksEvent("perks_more_about_zip");
    };
    PerksTrackingEvents.prototype.paymentMethodSelected = function (paymentMethod) {
        var data = {
            payment_method: paymentMethod
        };
        service.trackPerksEvent("perks_payment_method", data);
    };
    return PerksTrackingEvents;
}());
export default new PerksTrackingEvents();
